import { useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";
import { Logo } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/quotes`);
      setQuotes(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <main className="min-h-screen bg-[#fafafa]" data-testid="admin-page">
      <div className="bg-slate-900 py-5">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 flex items-center justify-between">
          <Logo dark />
          <span className="text-xs font-mono uppercase tracking-[0.25em] text-emerald-400">Pannello richieste</span>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-8 py-12">
        <div className="flex items-center justify-between mb-8">
          <h1 className="font-display text-2xl font-bold text-slate-900">Richieste di preventivo</h1>
          <button
            onClick={load}
            data-testid="admin-refresh-button"
            className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-700 transition-colors duration-300"
          >
            <RefreshCw className="w-4 h-4" />
            Aggiorna
          </button>
        </div>
        {loading ? (
          <p className="text-sm text-slate-500">Caricamento…</p>
        ) : quotes.length === 0 ? (
          <p className="text-sm text-slate-500" data-testid="admin-empty">Nessuna richiesta ricevuta finora.</p>
        ) : (
          <div className="grid gap-4">
            {quotes.map((q) => (
              <article key={q.id} className="rounded-2xl border border-slate-200 bg-white p-6" data-testid={`admin-quote-${q.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <h2 className="font-display text-lg font-bold text-slate-900">{q.name}</h2>
                    <p className="text-sm text-slate-500">{q.email} · {q.phone}</p>
                  </div>
                  <span className="rounded-full bg-emerald-50 border border-emerald-200 px-4 py-1.5 text-xs font-semibold text-emerald-700">
                    {q.vehicle_type}
                  </span>
                </div>
                <div className="mt-4 grid sm:grid-cols-3 gap-3 text-sm text-slate-600">
                  <p><span className="font-semibold text-slate-800">Ritiro:</span> {q.pickup_location || "—"}</p>
                  <p><span className="font-semibold text-slate-800">Dal:</span> {q.pickup_date || "—"}</p>
                  <p><span className="font-semibold text-slate-800">Al:</span> {q.return_date || "—"}</p>
                </div>
                {q.notes && <p className="mt-3 text-sm text-slate-500 italic">"{q.notes}"</p>}
                <p className="mt-3 text-xs font-mono text-slate-400">
                  {new Date(q.created_at).toLocaleString("it-IT")}
                </p>
              </article>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
